import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const emptyStatusIndicatorPresets = {
    components: {
        SeverityIndicator: () => _jsx(_Fragment, {}),
        StatusIndicator: () => _jsx(_Fragment, {}),
    },
};
//# sourceMappingURL=statusIndicator.js.map